import { render, staticRenderFns } from "./ServiceMaintenance.vue?vue&type=template&id=fdc77172&scoped=true"
var script = {}
import style0 from "./ServiceMaintenance.vue?vue&type=style&index=0&id=fdc77172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc77172",
  null
  
)

export default component.exports